import detectEthereumProvider from '@metamask/detect-provider';

export const walletAvailable = !!window.ethereum;

// eslint-disable-next-line func-names
export const Wallet = function () {
  this.available = walletAvailable;
  this.status = this.available ? 'disconnected' : 'unavailable';
  this.connected = false;
  this.accounts = [];

  const onAccountsChange = (accounts = []) => {
    this.accounts = accounts;
    ([this.selectedAccount = this.selectedAccount] = accounts);
  };

  this.connect = async () => {
    const provider = await detectEthereumProvider();
    this.available = this.available || !!provider;
    if (!this.available) {
      throw new Error('Etherium provider is not available');
    }
    this.status = 'connecting';
    // load chain
    /* eslint-disable no-undef */
    this.chainId = await ethereum.request({ method: 'eth_chainId' });
    // @TODO - handle/reload window
    ethereum.on('chainChanged', () => window.location.reload());
    ethereum.on('accountsChanged', onAccountsChange);
    // connect accounts
    const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
    onAccountsChange(accounts);
    this.status = 'connected';
    this.connected = true;
    // allow chaining
    return this;
  };

  this.isMetamaskInstalled = () => {
    if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) {
      return true;
    }
    return false;
  };
};
